import { ReactElement } from 'react';
import VictimInformation from '@components/FVSPage/VictimInformation';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep15(): ReactElement {
  return (
    <>
      <VictimInformation displayObject={fvsInfoDisplayObject} currentStepNo="step15" />
      <br />
      <p>I understand that by providing contact details, Fines Victoria may update its records using these details and that the fineholder may be contacted regarding their outstanding fines.</p>
    </>
  );
}
export default FVSStep15;
